import { render, staticRenderFns } from "./DomicilioParticular.vue?vue&type=template&id=270fc28a&"
import script from "./DomicilioParticular.vue?vue&type=script&lang=js&"
export * from "./DomicilioParticular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports